<template>
  <!-- COMPARE VEHICLES MODAL -->
  <div id="compare-vehicles" class="modal-summary modal fade" tabindex="-1" ref="comparisonModal">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header py-2">
          <h5 class="modal-title font-heading text-uppercase">Compare Vehicles</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span class="material-icons" aria-hidden="true">clear</span>
          </button>
        </div>
        <div class="modal-body p-0 pb-5">
          <div class="container">
            <div class="row">

              <!-- Electric Vehicle -->
              <div class="vehicle pb-0">
                <div class="vehicle-header w-100">
                  <p class="vehicle-title font-heading">Peterbilt {{ eName }}</p>
                  <p class="fuel-type text-uppercase font-heading">{{ eFuel }}</p>
                </div>
                <div class="vehicle-img">
                  <img :src="eIcon" :alt="eName" class="graphic img-fluid">
                  <img :src="eBanner" :alt="eName" class="logo img-fluid">
                </div>
              </div> 
              <!-- End Electric Vehicle -->

              <!-- Diesel Vehicle --> 
              <div class="vehicle pb-0">
                <div class="vehicle-header">
                  <p class="vehicle-title font-heading">Peterbilt {{ dName }}</p>
                  <p class="fuel-type text-uppercase font-heading">{{ dFuel }}</p>
                </div>
                <div class="vehicle-img">
                  <img :src="dIcon" :alt="dName" class="graphic img-fluid">
                  <img :src="dBanner" :alt="dName" class="logo img-fluid" style="max-height: 58px;">
                </div>
              </div> 
              <!-- End Diesel Vehicle -->

              <div class="vehicle extended border-0">
                <div class="vehicle-header chart-container">

                  <div class="labels pb-1">
                    <div class="item font-bold" v-if="usage == 'miles'">{{ formatPrice( (electricFuelCostPerMile + electricEquipmentCostPerMile + electricOtherCostPerMile) * currencyExchange ) }}/<small>mile</small> </div>
                    <div class="item font-bold" v-if="usage == 'hours'">{{ formatPrice( (electricFuelCostPerHour + electricEquipmentCostPerHour + electricOtherCostPerHour) * currencyExchange ) }}/<small>hour</small> </div>
                    <div class="item font-bold" v-if="usage == 'miles'">{{ formatPrice( (dieselFuelCostPerMile + dieselEquipmentCostPerMile + dieselOtherCostPerMile) * currencyExchange ) }}/<small>mile</small> </div>
                    <div class="item font-bold" v-if="usage == 'hours'">{{ formatPrice( (dieselFuelCostPerHour + dieselEquipmentCostPerHour + dieselOtherCostPerHour) * currencyExchange ) }}/<small>hour</small> </div>
                  </div>

                  <canvas ref="chartCompare"></canvas>

                  <div class="labels">
                    <div class="item font-bold">Electric</div>
                    <div class="item font-bold">Diesel</div>
                  </div>

                  <div class="legend">
                    <div class="legend-item">
                      <span class="swatch swatch-fuel"></span>
                      <span class="desc">Fuel Costs</span>
                    </div>
                    <div class="legend-item">
                      <span class="swatch swatch-equipment"></span>
                      <span class="desc">Equipment Costs</span>
                    </div>
                    <div class="legend-item">
                      <span class="swatch swatch-maintenance"></span>
                      <span class="desc">Maintenance &amp; Tire Costs</span>
                    </div>
                    <div class="legend-item">
                      <span class="swatch swatch-driver"></span>
                      <span class="desc">Driver Wages &amp; Benefits</span>
                    </div>
                    <div class="legend-item">
                      <span class="swatch swatch-other"></span>
                      <span class="desc">Other (Insurance, taxes, tolls)</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="vehicle" id="electric-comp">
                <div class="vehicle-calculations">
                  <span class="d-block font-heading">Electric Costs</span>
                  <div class="items">
                    <div class="item">
                      <span class="description">Annual Cost <small>(Per Vehicle)</small></span>
                      <span v-if="usage == 'miles'" class="value font-bold">{{ formatPrice( electricFuelCostAnnualMiles * currencyExchange, 0 ) }}</span>
                      <span v-if="usage == 'hours'" class="value font-bold">{{ formatPrice( electricFuelCostAnnualHours * currencyExchange, 0 ) }}</span>
                    </div>
                    <div class="item">
                      <span class="description">Total Cost Per {{ usage == 'hours' ? 'Hour' : 'Mile' }} <small>(Per Vehicle)</small></span>
                      <span v-if="usage == 'miles'" class="value font-bold">{{ formatPrice( electricFuelCostPerMile * currencyExchange ) }}</span>
                      <span v-if="usage == 'hours'" class="value font-bold">{{ formatPrice( electricFuelCostPerHour * currencyExchange ) }}</span>
                    </div>
                  </div>

                  <span class="d-block font-heading">Equipment Costs</span>
                  <div class="items">
                    <div class="item">
                      <span class="description">Annual Cost <small>(Per Vehicle)</small></span>
                      <span class="value font-bold">{{ formatPrice( electricEquipmentCost["annual-cost"] * currencyExchange, 0 ) }}</span>
                    </div>
                    <div class="item">
                      <span class="description">Total Cost Per {{ usage == 'hours' ? 'Hour' : 'Mile' }} <small>(Per Vehicle)</small></span>
                      <span v-if="usage == 'miles'" class="value font-bold">{{ formatPrice( electricEquipmentCostPerMile * currencyExchange ) }}</span>
                      <span v-if="usage == 'hours'" class="value font-bold">{{ formatPrice( electricEquipmentCostPerHour * currencyExchange ) }}</span>
                    </div>
                  </div>

                  <span class="d-block font-heading">Other Costs</span>
                  <div class="items">
                    <div class="item">
                      <span class="description">Annual Cost <small>(Per Vehicle)</small></span>
                      <span class="value font-bold">{{ formatPrice( electricOtherCost["annual-cost"] * currencyExchange, 0 ) }}</span>
                    </div>
                    <div class="item border-bottom-0">
                      <span class="description">Total Cost Per {{ usage == 'hours' ? 'Hour' : 'Mile' }} <small>(Per Vehicle)</small></span>
                      <span v-if="usage == 'miles'" class="value font-bold">{{ formatPrice( electricOtherCostPerMile * currencyExchange ) }}</span>
                      <span v-if="usage == 'hours'" class="value font-bold">{{ formatPrice( electricOtherCostPerHour * currencyExchange ) }}</span>
                    </div>
                  </div>
                </div>
              </div> 

              <div class="vehicle" id="diesel-comp">
                <div class="vehicle-calculations">
                  <span class="d-block font-heading">Fuel Costs</span>
                  <div class="items">
                    <div class="item">
                      <span class="description">Annual Cost <small>(Per Vehicle)</small></span>
                      <span v-if="usage == 'miles'" class="value font-bold">{{ formatPrice( dieselFuelCostAnnualMiles * currencyExchange, 0 ) }}</span>
                      <span v-if="usage == 'hours'" class="value font-bold">{{ formatPrice( dieselFuelCostAnnualHours * currencyExchange, 0 ) }}</span>
                    </div>
                    <div class="item">
                      <span class="description">Total Cost Per {{ usage == 'hours' ? 'Hour' : 'Mile' }} <small>(Per Vehicle)</small></span>
                      <span v-if="usage == 'miles'" class="value font-bold">{{ formatPrice( dieselFuelCostPerMile * currencyExchange ) }}</span>
                      <span v-if="usage == 'hours'" class="value font-bold">{{ formatPrice( dieselFuelCostPerHour * currencyExchange ) }}</span>
                    </div>
                  </div>

                  <span class="d-block font-heading">Equipment Costs</span>
                  <div class="items">
                    <div class="item">
                      <span class="description">Annual Cost <small>(Per Vehicle)</small></span>
                      <span v-if="usage == 'miles'" class="value font-bold">{{ formatPrice( dieselEquipmentCost["annual-cost"] * currencyExchange, 0 ) }}</span>
                      <span v-if="usage == 'hours'" class="value font-bold">{{ formatPrice( dieselEquipmentCost["annual-cost"] * currencyExchange, 0 ) }}</span>
                    </div>
                    <div class="item">
                      <span class="description">Total Cost Per {{ usage == 'hours' ? 'Hour' : 'Mile' }} <small>(Per Vehicle)</small></span>
                      <span v-if="usage == 'miles'" class="value font-bold">{{ formatPrice( dieselEquipmentCostPerMile * currencyExchange ) }}</span>
                      <span v-if="usage == 'hours'" class="value font-bold">{{ formatPrice( dieselEquipmentCostPerHour * currencyExchange ) }}</span>
                    </div>
                  </div>

                  <span class="d-block font-heading">Other Costs</span>
                  <div class="items">
                    <div class="item">
                      <span class="description">Annual Cost <small>(Per Vehicle)</small></span>
                      <span class="value font-bold">{{ formatPrice( dieselOtherCost["annual-cost"] * currencyExchange, 0 ) }}</span>
                    </div>
                    <div class="item border-bottom-0">
                      <span class="description">Total Cost Per {{ usage == 'hours' ? 'Hour' : 'Mile' }} <small>(Per Vehicle)</small></span>
                      <span v-if="usage == 'miles'" class="value font-bold">{{ formatPrice( dieselOtherCostPerMile * currencyExchange ) }}</span>
                      <span v-if="usage == 'hours'" class="value font-bold">{{ formatPrice( dieselOtherCostPerHour * currencyExchange ) }}</span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import Chart from 'chart.js'
  import 'chartjs-plugin-style'

  export default {
    name: 'VehicleCompareModal',
    data () {
      return {
        vehicleDiesel : [],
        vehicleElectric : [],
        usage: '',

        dName : '',
        dFuel : '',
        dIcon : '',
        dBanner : '',
        dieselCost: {},
        dieselEquipmentCost: {},
        dieselOtherCost: {},
        dieselFuelCostAnnualMiles: 0,
        dieselFuelCostAnnualHours: 0,
        dieselFuelCostPerMile: 0,
        dieselFuelCostPerHour: 0,
        dieselEquipmentCostPerMile: 0,
        dieselEquipmentCostPerHour: 0,
        dieselOtherCostPerMile: 0,
        dieselOtherCostPerHour: 0,


        eName : '',
        eFuel : '',
        eIcon : '',
        eBanner : '',
        electricCost: {},
        electricEquipmentCost: {},
        electricOtherCost: {},
        electricFuelCostAnnualMiles: 0,
        electricFuelCostAnnualHours: 0,
        electricFuelCostPerMile: 0,
        electricFuelCostPerHour: 0,
        electricEquipmentCostPerMile: 0,
        electricEquipmentCostPerHour: 0,
        electricOtherCostPerMile: 0,
        electricOtherCostPerHour: 0,
        pto: 0,
        ptoOperatingDays: 250,
        ptoOperatingTime: 8,

        currencyType: '',
        currencyExchange: 0
      }
    },
    mounted() {
      //this.updateCosts()
      $(this.$refs.comparisonModal).on('hidden.bs.modal', this.emitClose)
      $(this.$refs.comparisonModal).on('show.bs.modal', this.buildChart)
    },
    methods: {
      formatPrice(value, spaces = 2) {
        let val = (value/1).toFixed(spaces)
        return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
      updateCosts() {

        // Set currency
        this.currencyType = sessionStorage.getItem('currency')
        this.currencyExchange = this.currencyType == 'canada' ? Number(localStorage.getItem('USDtoCAD')) : 1

        // Get vehicle info from storage
        this.vehicleDiesel = JSON.parse(localStorage.getItem('calculatorVehicleDiesel'))
        this.vehicleElectric = JSON.parse(localStorage.getItem('calculatorVehicleElectric'))
        this.usage = sessionStorage.getItem('usage')

        // Get and set current values for diesel
        this.dieselCost = JSON.parse(sessionStorage.getItem('dieselFuelCost'))
        this.dieselEquipmentCost = JSON.parse(sessionStorage.getItem('dieselEquipmentCost'))
        this.dieselOtherCost = JSON.parse(sessionStorage.getItem('dieselOtherCost'))

        // Diesel Totals
        this.dieselFuelCostAnnualMiles = this.vehicleDiesel.fuel.mileage == 0 ? 0 : parseFloat((this.vehicleDiesel.fuel.mileage / this.vehicleDiesel.fuel.milesPerGallon ) * this.vehicleDiesel.fuel.fuelCostPerGallon)
        this.dieselFuelCostAnnualHours = this.vehicleDiesel.fuel.hours == 0 ? 0 : parseFloat(this.vehicleDiesel.fuel.hours * this.vehicleDiesel.fuel.gallonsPerHour * this.vehicleDiesel.fuel.fuelCostPerGallon)
        this.dieselFuelCostPerMile = this.vehicleDiesel.fuel.mileage == 0 ? 0 : parseFloat(this.dieselFuelCostAnnualMiles / this.vehicleDiesel.fuel.mileage)
        this.dieselFuelCostPerHour = this.vehicleDiesel.fuel.hours == 0 ? 0 : parseFloat(this.dieselFuelCostAnnualHours / this.vehicleDiesel.fuel.hours)
        this.dieselEquipmentCostPerMile = this.vehicleDiesel.fuel.mileage == 0 ? 0 : parseFloat(this.dieselEquipmentCost['annual-cost'] / this.vehicleDiesel.fuel.mileage)
        this.dieselEquipmentCostPerHour = this.vehicleDiesel.fuel.hours == 0 ? 0 : parseFloat(this.dieselEquipmentCost['annual-cost'] / this.vehicleDiesel.fuel.hours)
        this.dieselOtherCostPerMile = this.vehicleDiesel.fuel.mileage == 0 ? 0 : parseFloat(this.dieselOtherCost['annual-cost'] / this.vehicleDiesel.fuel.mileage)
        this.dieselOtherCostPerHour = this.vehicleDiesel.fuel.hours == 0 ? 0 : parseFloat(this.dieselOtherCost['annual-cost'] / this.vehicleDiesel.fuel.hours)

        this.dName = this.vehicleDiesel.name
        this.dFuel = this.vehicleDiesel.fuel.type
        this.dIcon = this.vehicleDiesel.icon
        this.dBanner = this.vehicleDiesel.bannerAlt

        // Get and set current values for electric
        this.electricCost = JSON.parse(sessionStorage.getItem('electricFuelCost'))
        this.electricEquipmentCost = JSON.parse(sessionStorage.getItem('electricEquipmentCost'))
        this.electricOtherCost = JSON.parse(sessionStorage.getItem('electricOtherCost'))

        this.pto = this.electricCost.pto ? this.electricCost.pto : 0
        this.ptoOperatingDays = this.electricCost.ptoOperatingDays
        this.ptoOperatingTime = this.electricCost.ptoOperatingTime
        this.eName = this.vehicleElectric.name
        this.eFuel = this.vehicleElectric.fuel.type
        this.eIcon = this.vehicleElectric.icon
        this.eBanner = this.vehicleElectric.bannerAlt

        let powerConsumption = Number(this.electricCost.powerConsumption)
        // If there is no vocational body selected or available, default to 0
        let bodyPowerConsumption = Object.keys(this.electricCost.activeBodyType).length > 0 ? Number(this.electricCost.activeBodyType.bodyPowerConsumption) : 0
        // If there is no vocational body selected or available, default to 0
        let collectionsPerDay = Object.keys(this.electricCost.activeBodyType).length > 0 ? Number(this.electricCost.activeBodyType.collectionsPerDay) : 0

        // Electric Totals
        this.electricFuelCostAnnualMiles = this.vehicleElectric.fuel.mileage == 0 ? 0 : parseFloat(
          (this.vehicleElectric.fuel.mileage * powerConsumption * this.vehicleElectric.fuel.electricityCost) + 
          (this.vehicleElectric.fuel.electricityCost * bodyPowerConsumption * collectionsPerDay * this.ptoOperatingDays) + this.pto )

        this.electricFuelCostAnnualHours = this.vehicleElectric.fuel.hours == 0 ? 0 : parseFloat(
          (this.vehicleElectric.fuel.hours * powerConsumption * this.vehicleElectric.fuel.electricityCost) + 
          (this.vehicleElectric.fuel.electricityCost * bodyPowerConsumption * collectionsPerDay * this.ptoOperatingDays) + this.pto )

        this.electricFuelCostPerMile = this.vehicleElectric.fuel.mileage == 0 ? 0 : Number((this.electricFuelCostAnnualMiles / this.vehicleElectric.fuel.mileage).toFixed(2))
        this.electricFuelCostPerHour = this.vehicleElectric.fuel.hours == 0 ? 0 : Number((this.electricFuelCostAnnualHours / this.vehicleElectric.fuel.hours).toFixed(2))

        this.electricEquipmentCostPerMile = this.vehicleElectric.fuel.mileage == 0 ? 0 : Number((this.electricEquipmentCost['annual-cost'] / this.vehicleElectric.fuel.mileage).toFixed(2))
        this.electricEquipmentCostPerHour = this.vehicleElectric.fuel.hours == 0 ? 0 : Number((this.electricEquipmentCost['annual-cost'] / this.vehicleElectric.fuel.hours).toFixed(2))

        this.electricOtherCostPerMile = this.vehicleElectric.fuel.mileage == 0 ? 0 : Number((this.electricOtherCost['annual-cost'] / this.vehicleElectric.fuel.mileage).toFixed(2))
        this.electricOtherCostPerHour = this.vehicleElectric.fuel.hours == 0 ? 0 : Number((this.electricOtherCost['annual-cost'] / this.vehicleElectric.fuel.hours).toFixed(2))


        let currentVehicle
        if (this.$route.path.includes('/diesel')) {
          currentVehicle = this.eName
        }else {
          currentVehicle = this.dName
        }
        // Tracking
        window.gtag('event', 'Click', {
          'event_category': 'Cost Calculator - Compare',
          'event_label': currentVehicle
        })
      },
      emitClose() {
        this.$emit('modalClosed', true)
      },
      buildChart() {

        this.updateCosts()

        new Chart(this.$refs.chartCompare, {
          type: 'bar',
          data: {
            //labels: [this.usage == 'miles' ? 'Operating Cost Comparison ($/mile)' : 'Operating Cost Comparison ($/hour)'],
            labels: [''],
            datasets: [
              {
                label: 'Fuel Costs',
                stack: 'stack-1',
                data: [this.usage == 'miles' ? (this.electricFuelCostPerMile).toFixed(2) : (this.electricFuelCostPerHour).toFixed(2)],
                backgroundColor: '#44AD4C',
                categoryPercentage: 1.0,
                barPercentage: 0.75,
                bevelWidth: 3,
                bevelHighlightColor: 'rgba(255, 255, 255, 0.75)',
                bevelShadowColor: 'rgba(0, 0, 0, 0.5)'
              },
              {
                label: 'Equipment Costs',
                stack: 'stack-1',
                data: [this.usage == 'miles' ? this.electricEquipmentCost['cost-per-mile'] : this.electricEquipmentCost['cost-per-hour']],
                backgroundColor: '#FFC000',
                categoryPercentage: 1.0,
                barPercentage: 0.75,
                bevelWidth: 3,
                bevelHighlightColor: 'rgba(255, 255, 255, 0.75)',
                bevelShadowColor: 'rgba(0, 0, 0, 0.5)'
              },
              {
                label: 'Maintenance & Tire Costs',
                stack: 'stack-1',
                data: [this.usage == 'miles' ? (this.electricOtherCost['cost-maintenance'] / this.vehicleElectric.fuel.mileage).toFixed(2) : (this.electricOtherCost['cost-maintenance'] / this.vehicleElectric.fuel.hours).toFixed(2)],
                backgroundColor: '#FF8500',
                categoryPercentage: 1.0,
                barPercentage: 0.75,
                bevelWidth: 3,
                bevelHighlightColor: 'rgba(255, 255, 255, 0.75)',
                bevelShadowColor: 'rgba(0, 0, 0, 0.5)'
              },
              {
                label: 'Driver Wages & Benefits',
                stack: 'stack-1',
                data: [this.usage == 'miles' ? (this.electricOtherCost['cost-driver'] / this.vehicleElectric.fuel.mileage).toFixed(2) : (this.electricOtherCost['cost-driver'] / this.vehicleElectric.fuel.hours).toFixed(2)],
                backgroundColor: '#00B3FF',
                categoryPercentage: 1.0,
                barPercentage: 0.75,
                bevelWidth: 3,
                bevelHighlightColor: 'rgba(255, 255, 255, 0.75)',
                bevelShadowColor: 'rgba(0, 0, 0, 0.5)'
              },
              {
                label: 'Other (Insurance, taxes, tolls)',
                stack: 'stack-1',
                data: [this.usage == 'miles' ? ((this.electricOtherCost['cost-insurance'] + this.electricOtherCost['cost-taxes'] + this.electricOtherCost['cost-tolls']) / this.vehicleElectric.fuel.mileage).toFixed(2) : ((this.electricOtherCost['cost-insurance'] + this.electricOtherCost['cost-taxes'] + this.electricOtherCost['cost-tolls']) / this.vehicleElectric.fuel.hours).toFixed(2)],
                backgroundColor: '#FF0000',
                categoryPercentage: 1.0,
                barPercentage: 0.75,
                bevelWidth: 3,
                bevelHighlightColor: 'rgba(255, 255, 255, 0.75)',
                bevelShadowColor: 'rgba(0, 0, 0, 0.5)'
              },

              {
                label: 'Fuel Costs',
                stack: 'stack-2',
                data: [this.usage == 'miles' ? (this.dieselFuelCostPerMile).toFixed(2) : (this.dieselFuelCostPerHour).toFixed(2)],
                backgroundColor: '#44AD4C',
                categoryPercentage: 1.0,
                barPercentage: 0.75,
                bevelWidth: 3,
                bevelHighlightColor: 'rgba(255, 255, 255, 0.75)',
                bevelShadowColor: 'rgba(0, 0, 0, 0.5)'
              },
              {
                label: 'Equipment Costs',
                stack: 'stack-2',
                data: [this.usage == 'miles' ? this.dieselEquipmentCost['cost-per-mile'] : this.dieselEquipmentCost['cost-per-hour']],
                backgroundColor: '#FFC000',
                categoryPercentage: 1.0,
                barPercentage: 0.75,
                bevelWidth: 3,
                bevelHighlightColor: 'rgba(255, 255, 255, 0.75)',
                bevelShadowColor: 'rgba(0, 0, 0, 0.5)'
              },
              {
                label: 'Maintenance & Tire Costs',
                stack: 'stack-2',
                data: [this.usage == 'miles' ? (this.dieselOtherCost['cost-maintenance'] / this.vehicleDiesel.fuel.mileage).toFixed(2) : (this.dieselOtherCost['cost-maintenance'] / this.vehicleDiesel.fuel.hours).toFixed(2)],
                backgroundColor: '#FF8500',
                categoryPercentage: 1.0,
                barPercentage: 0.75,
                bevelWidth: 3,
                bevelHighlightColor: 'rgba(255, 255, 255, 0.75)',
                bevelShadowColor: 'rgba(0, 0, 0, 0.5)'
              },
              {
                label: 'Driver Wages & Benefits',
                stack: 'stack-2',
                data: [this.usage == 'miles' ? (this.dieselOtherCost['cost-driver'] / this.vehicleDiesel.fuel.mileage).toFixed(2) : (this.dieselOtherCost['cost-driver'] / this.vehicleDiesel.fuel.hours).toFixed(2)],
                backgroundColor: '#00B3FF',
                categoryPercentage: 1.0,
                barPercentage: 0.75,
                bevelWidth: 3,
                bevelHighlightColor: 'rgba(255, 255, 255, 0.75)',
                bevelShadowColor: 'rgba(0, 0, 0, 0.5)'
              },
              {
                label: 'Other (Insurance, taxes, tolls)',
                stack: 'stack-2',
                data: [this.usage == 'miles' ? ((this.dieselOtherCost['cost-insurance'] + this.dieselOtherCost['cost-taxes'] + this.dieselOtherCost['cost-tolls']) / this.vehicleDiesel.fuel.mileage).toFixed(2) : ((this.dieselOtherCost['cost-insurance'] + this.dieselOtherCost['cost-taxes'] + this.dieselOtherCost['cost-tolls']) / this.vehicleDiesel.fuel.hours).toFixed(2)],
                backgroundColor: '#FF0000',
                categoryPercentage: 1.0,
                barPercentage: 0.75,
                bevelWidth: 3,
                bevelHighlightColor: 'rgba(255, 255, 255, 0.75)',
                bevelShadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            ]
          },
          options: {
            scales: {
              yAxes: [{
                stacked: true,
                ticks: {
                  fontSize: 16,
                  stepSize: 1,
                  callback: function(value) {
                    return '$' + Number(value).toFixed(0).replace(/./g, function(c, i, a) {
                      return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
                    })
                  }
                },
                scaleLabel: {
                  display: true,
                  labelString: this.usage == 'miles' ? 'Cost Per Mile' : 'Cost Per Hour',
                  fontSize: 16,
                  fontColor: '#000'
                }
              }]
            },
            tooltips: {
              callbacks: {
                label: function(tooltipItem, data) {
                  var label = data.datasets[tooltipItem.datasetIndex].label || '';

                    return label + ': ' + '$' + Number(tooltipItem.yLabel).toFixed(2).replace(/./g, function(c, i, a) {
                      return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
                    })
                  }
                }
            },
            label: { display: false },
            legend: { display: false },
            animation: { duration: 5000 }
          }
        })
      }
    }
  }
</script>